import { useTranslation } from 'react-i18next';
import type { EconomicsTreeModel } from '../../types/economicsTypes';
import { EconomicsPlanRow } from './EconomicsPlanRow';
import styles from './Economics.module.css';

interface EconomicsTreeProps {
  tree: EconomicsTreeModel;
  canWrite: boolean;
  onToggleKeys: (keys: string[], completed: boolean) => void;
  onToggleLeaf: (key: string, completed: boolean) => void;
  onToggleClaim: (key: string, claimed: boolean) => void;
  onOverrideChange: (key: string, value: number | null, note: string | null) => void;
}

export const EconomicsTree = ({
  tree,
  canWrite,
  onToggleKeys,
  onToggleLeaf,
  onToggleClaim,
  onOverrideChange
}: EconomicsTreeProps) => {
  const { t } = useTranslation();

  if (tree.plans.length === 0) {
    return <div className={styles.emptyState}>{t('economics-empty')}</div>;
  }

  return (
    <div className={styles.tree}>
      {tree.plans.map((plan) => (
        <EconomicsPlanRow
          key={plan.treatmentPlanId}
          node={plan}
          canWrite={canWrite}
          onToggleKeys={onToggleKeys}
          onToggleLeaf={onToggleLeaf}
          onToggleClaim={onToggleClaim}
          onOverrideChange={onOverrideChange}
        />
      ))}
    </div>
  );
};
